import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_ENDPOINT;

export const GetServiceJob = createAsyncThunk(
    'service-job/list', 
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.get(`${API_URL}/service-job/list`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching job service:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch items');
        }
    }
);

const serviceJobSlice = createSlice({
    name: 'serviceJob',
    initialState: {
        service_job: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(GetServiceJob.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(GetServiceJob.fulfilled, (state, action) => {
            state.isLoading = false;
            state.service_job = action.payload;
        })
        .addCase(GetServiceJob.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
    },
});

export default serviceJobSlice.reducer;